'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selector = {
  init: function init(render) {
    var _this = this;

    if (render) {
      return _store2.default.getAccounts().then(function (accounts) {
        var $accountName = _store2.default.getContext() ? _store2.default.getContext().name || 'p-' + _store2.default.getContext().pCode : 'Select an Account';
        var $account = '<li class="nav__list__item">' + $accountName + '</li>';
        _this.accounts = accounts;
        var $selector = _this.selector();
        (0, _jquery2.default)(_constants.DOM_CLASSES.accountSelectorBtn + ' .nav__list__item').remove();
        if ((0, _jquery2.default)('.selector').length) {
          (0, _jquery2.default)('.selector').remove();
        }
        (0, _jquery2.default)(_constants.DOM_CLASSES.accountSelectorBtn).removeClass(_constants.DOM_CLASSES.accountSelectorBtnDisabled).append($account);
        (0, _jquery2.default)(_constants.DOM_IDS.header).append($selector);
        return _bluebird2.default.resolve();
      });
    }
    return _bluebird2.default.resolve();
  },
  selectorAccounts: function selectorAccounts() {
    var html = '';
    var selected = _store2.default.getContext() ? _store2.default.getContext().pCode : null;
    this.accounts.filter(function (acct) {
      return acct.name.toLowerCase().indexOf(_store2.default.accountsFilter) > -1;
    }).forEach(function (account) {
      html += '\n        <div class="selector__content__list__items__item ' + (selected === account.pCode ? 'selector__content__list__items__item--selected' : '') + '" data-pcode="' + account.pCode + '"  data-rtbid="' + account.rtbid + '">\n          <div class="selector__content__column selector__content__column--70">\n            <h3>' + (account.name || '(Untitled Account)') + '</h3>\n          </div>\n          <div class="selector__content__column selector__content__column--30 selector__content__column--right">\n            <p>p-' + account.pCode + '</p>\n          </div>\n        </div>\n      ';
    });
    return html;
  },
  selector: function selector() {
    var $selectorAccounts = this.selectorAccounts();
    return '\n      <div class="selector selector--accounts">\n        <div class="selector__exit"></div>\n        <div class="selector__content">\n          <div class="selector__content__heading">\n            <h1>Accounts</h1>\n          </div>\n          <div class="selector__content__list">\n            <div class="selector__content__list__search">\n              <input class="selector__content__list__search__input" type="text" placeholder="Search for an account name" />\n            </div>\n            <div class="selector__content__list__headings">\n              <div class="selector__content__column selector__content__column--70">\n                <label>Name</label>\n              </div>\n              <div class="selector__content__column selector__content__column--30 selector__content__column--right">\n                <label>ID</label>\n              </div>\n            </div>\n            <div class="selector__content__list__items">\n              ' + $selectorAccounts + '\n            </div>\n          </div>\n        </div>\n      </div>';
  },
  refreshAccountsList: function refreshAccountsList() {
    var $selectorAccounts = this.selectorAccounts();
    (0, _jquery2.default)('.selector__content__list__items').html($selectorAccounts);
  }
};

exports.default = selector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/selector.js
// module id = 199
// module chunks = 0